<template>
  <div class="mask toast" :class="$bus.toast.isMsg ? 'msg': ''" v-show="show" @click="hideToast">
    <div ref="toast" class="toast-inner">
      <span>{{$bus.toast.text}}</span>
    </div>
  </div>
</template>

<script>
import VueAnime from '@/utils/animate.js'
const anime = new VueAnime()
export default {
  props: {
    show: Boolean
  },
  data () {
    return {
      timer: null
    }
  },
  watch: {
    show (val) {
      if (val) {
        if (!this.$bus.toast.isMsg) {
          this.showToast()
        } else {
          this.showMessage()
        }
      }
    }
  },
  methods: {
    showToast () {
      anime.toast(this.$refs.toast)
      this.timer = setTimeout(() => {
        this.hideToast()
      }, 2000)
    },
    hideToast () {
      clearTimeout(this.timer)
      if (this.$bus.toast.isMsg) {
        return false
      } else {
        anime.toastHide(this.$refs.toast, () => {
          this.$bus.toast.show = false
        })
      }
    },
    showMessage () {
      anime.message(this.$refs.toast)
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  display: none;
}
.toast {
  @include px2res(font-size, 32);
  @include flexrc;
  color: #fff;
}
.mask.msg {
  background: rgba(0, 0, 0, 0.8);
}
.toast.msg {
  align-items: center;
  transform: translate(0, 0);
}
.toast-inner {
  @include flexrc;
  text-align: center;
  max-width: 96%;
  margin: 0 auto;
  letter-spacing: 1px;
  line-height: 1;
  @include flexrc;
  @include px2res(height, 176);
  @include px2res(min-width, 920);
  @include px2res(font-size, 32);
  @include px2res(padding, 0, 30);
  span {
    flex: auto;
    @include px2res(margin, 9, auto, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Toast.vue